import React from 'react';
import { bool, shape, func, string } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { prepareSocialSharingImages } from '../../util/seo';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  Page,
  NamedLink,
  SupportChatWidget,
  Icon,
} from '../../components';
import config from '../../config';

import { helpContentFor } from './HelpPage.helpers';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import SearchArticles from './SearchArticles';
import helpPageSharingImage from '../../assets/attractrHelp-1200x630.avif';
import css from './HelpPage.module.css';

const Topic = props => {
  const { topic } = props;
  return (
    <NamedLink className={css.topic} name="TopicPage" params={{ topicId: topic.key }}>
      <span className={css.topicIcon}>
        <Icon name={topic.icon} size={20} />
      </span>
      <div className={css.topicContent}>
        <h3 className={css.topicTitle}>{topic.label}</h3>
        <p className={css.topicText}>{topic.description}</p>
      </div>
      <span className={css.topicArrow}>
        <Icon name="chevronRight" />
      </span>
    </NamedLink>
  );
};

const HelpPageComponent = props => {
  const { intl, scrollingDisabled, history } = props;
  const helpConfig = helpContentFor(intl.locale);

  const topics = helpConfig.topics;
  const articles = helpConfig.articles;

  const schemaTitle = intl.formatMessage(
    {
      id: 'HelpPage.schemaTitle',
    },
    {
      siteTitle: config.siteTitle,
    }
  );
  const schemaDescription = intl.formatMessage({ id: 'HelpPage.schemaDescription' });
  const schemaKeywords = intl.formatMessage({ id: 'HelpPage.schemaKeywords' });

  return (
    <Page
      title={schemaTitle}
      description={schemaDescription}
      keywords={schemaKeywords}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'HelpPage',
        name: schemaTitle,
      }}
      socialSharing={{
        images1200: prepareSocialSharingImages([helpPageSharingImage]),
      }}
      scrollingDisabled={scrollingDisabled}
      currentPage="HelpPage"
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="HelpPage" />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          <div className={css.pageContent}>
            <div className={css.pageContentFlex}>
              <h1 className={css.pageTitle}>
                <FormattedMessage id="HelpPage.title" />
              </h1>
              <SearchArticles intl={intl} options={articles} history={history} />
              <div className={css.topicsWrapper}>
                <h2 className={css.topicsTitle}>
                  <FormattedMessage id="HelpPage.topicsTitle" />
                </h2>
                <div className={css.topics}>
                  {topics.map(t => {
                    return <Topic key={t.key} topic={t} />;
                  })}
                </div>
              </div>
              <div className={css.contact}>
                <span className={css.contactText}>
                  <FormattedMessage id="HelpPage.contactText" />
                </span>
                <NamedLink className={css.contactLink} name="ContactPage">
                  <FormattedMessage id="HelpPage.contactLink" />
                </NamedLink>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
          <SupportChatWidget currentPage="HelpPage" />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

HelpPageComponent.propTypes = {
  intl: intlShape.isRequired,
  scrollingDisabled: bool.isRequired,

  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const HelpPage = compose(connect(mapStateToProps), injectIntl, withRouter)(HelpPageComponent);

export default HelpPage;
